import React from "react";
import Navbar from "./Navbar";
import RenewalBanner from "./RenewalBanner";
import TrialEndingBanner from "./TrialEndingBanner";
import ResumeSessionBanner from "./ResumeSessionBanner";

export default function Layout({ children }) {
    return (
        <div className="min-h-screen bg-background text-foreground">
            <Navbar />
            <RenewalBanner />
            <TrialEndingBanner />
            <ResumeSessionBanner />
            <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:py-10">{children}</main>
        </div>
    );
}
